import { JourneyForUser, Token, JourneysApi, GetJourneysUserRequest } from "@devour/client";
import getConfig from "@/utils/getConfig";
import { useQuery } from "@tanstack/react-query";

async function fetchJourneysForUser(fullToken: Token, query: GetJourneysUserRequest): Promise<Array<JourneyForUser>> {
    return await new JourneysApi(getConfig(fullToken)).getJourneysUser(query);
}

function getJourneysForUserQuery(fullToken: Token, query: GetJourneysUserRequest) {
    return {
        queryKey: [
            "journeys-user",
            fullToken?.id ?? "unauthenticated",
            query,
        ],
        queryFn: () => fetchJourneysForUser(fullToken, query),
        placeholderData: (previousData: any) => previousData, // v5 replacement for keepPreviousData
        /*
         * Matches the quest-config posture (5 min): a journey is authoring, and
         * an Admin edit in the Journey Editor IS the deploy — a long staleTime
         * would hide a re-authored track behind a hard refresh.
         */
        staleTime: 5 * 60000,
        refetchOnWindowFocus: false,
        enabled: Boolean(query.surface),
    } as const;
}

export function useGetJourneysForUser(fullToken: Token, query: GetJourneysUserRequest) {
    return useQuery(getJourneysForUserQuery(fullToken, query));
}
